/**
 * SEO-Optimized Footer Mobile Accordion
 * Prevents content duplication by dynamically copying content from desktop to mobile
 */

document.addEventListener('DOMContentLoaded', function() {
  // Wait for all elements to load
  setTimeout(() => {
    // Find the main footer section with the correct ID pattern
    const mainFooter = document.querySelector('[class*="footer-sections--"]');
    
    if (!mainFooter) {
      return;
    }
    
    // Extract the full section ID from the class name
    const classList = Array.from(mainFooter.classList);
    
    let sectionId = null;
    for (const className of classList) {
      const match = className.match(/footer-(sections--\w+)/);
      if (match && match[1]) {
        sectionId = match[1];
        break;
      }
    }
    
    if (!sectionId) {
      return;
    }
    
    // Get all menu blocks in this section
    const desktopMenus = document.querySelectorAll(`.footer-column-desktop-${sectionId}`);
    const mobileMenus = document.querySelectorAll(`.footer-column-mobile-${sectionId}`);
    
    desktopMenus.forEach((desktopMenu, index) => {
      const mobileMenu = mobileMenus[index];
      if (!mobileMenu) {
        return;
      }
      
      // Copy content from desktop to mobile tab
      const desktopContent = desktopMenu.querySelector(`.footer-menu-list-${sectionId}`);
      const mobileTabText = mobileMenu.querySelector(`.footer-tab-text-${sectionId}`);
      
      if (desktopContent && mobileTabText) {
        // Clear existing content first
        mobileTabText.innerHTML = '';
        // Clone the content and insert into mobile tab
        const clonedContent = desktopContent.cloneNode(true);
        mobileTabText.appendChild(clonedContent);
      }
      
      // Setup accordion functionality
      const toggle = mobileMenu.querySelector(`.footer-tab-toggle-${sectionId}`);
      const tabText = mobileMenu.querySelector(`.footer-tab-text-${sectionId}`);
      const arrow = mobileMenu.querySelector(`.footer-tab-toggle-arrow-${sectionId}`);
      const heightCal = mobileMenu.querySelector(`.footer-tab-height-cal-${sectionId}`);
      
      if (toggle && tabText && arrow && heightCal) {
        // Initialize accordion state
        let isAccordionOpen = false;
        
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          
          if (isAccordionOpen) {
            // Close accordion
            tabText.style.display = 'none';
            tabText.style.height = '0px';
            tabText.style.paddingTop = '0px';
            tabText.style.paddingBottom = '0px';
            arrow.style.transform = 'rotate(0deg)';
            isAccordionOpen = false;
          } else {
            // Open accordion
            // Calculate height from hidden reference
            const referenceHeight = heightCal.offsetHeight;
            tabText.style.display = 'block';
            tabText.style.height = referenceHeight + 'px';
            tabText.style.paddingTop = '20px';
            tabText.style.paddingBottom = '20px';
            arrow.style.transform = 'rotate(180deg)';
            isAccordionOpen = true;
          }
        });
      }
    });
  }, 200);
});
